import Header from '@/components/landing/layout/Header';
import Footer from '@/components/landing/layout/Footer';

const Privacy = () => {
  return (
    <>
      
      <div className="tw-flex tw-flex-col tw-min-h-screen">
        <Header />
        <main className="tw-flex-grow tw-pt-24 tw-pb-16">
          <div className="tw-container tw-mx-auto tw-px-4">
            <div className="tw-max-w-4xl tw-mx-auto">
              <h1 className="tw-text-3xl tw-font-bold tw-mb-8">Privacy Policy</h1>

              <div className="tw-prose tw-prose-lg">
                <p className="tw-mb-4">
                  Last Updated:{' '}
                  {new Date().toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                  })}
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">1. Introduction</h2>
                <p>
                  At Protega.ai, we respect your privacy and are committed to protecting your personal data.
                  This Privacy Policy explains how we collect, use, and safeguard your information when you
                  use our services.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">2. Information We Collect</h2>
                <p>We may collect the following types of information:</p>
                <ul className="tw-list-disc tw-pl-6 tw-mb-4">
                  <li><strong>Personal Information:</strong> Name, email address, contact details, and other information you provide when using our services.</li>
                  <li><strong>Usage Data:</strong> Information about how you use our website and services.</li>
                  <li><strong>Device Information:</strong> Details about the device you use to access our services, including IP address, browser type, and operating system.</li>
                </ul>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">3. How We Use Your Information</h2>
                <p>We use your information for the following purposes:</p>
                <ul className="tw-list-disc tw-pl-6 tw-mb-4">
                  <li>To provide and maintain our services</li>
                  <li>To notify you about changes to our services</li>
                  <li>To allow you to participate in interactive features of our services</li>
                  <li>To provide customer support</li>
                  <li>To gather analysis or valuable information to improve our services</li>
                  <li>To monitor the usage of our services</li>
                  <li>To detect, prevent, and address technical issues</li>
                </ul>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">4. Data Security</h2>
                <p>
                  We implement appropriate security measures to protect your personal information from
                  unauthorized access, alteration, disclosure, or destruction. However, no method of
                  transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee
                  absolute security.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">5. Sharing Your Information</h2>
                <p>We may share your information with:</p>
                <ul className="tw-list-disc tw-pl-6 tw-mb-4">
                  <li><strong>Service Providers:</strong> Third parties that help us provide and maintain our services.</li>
                  <li><strong>Business Partners:</strong> Companies we partner with to offer integrated or combined services.</li>
                  <li><strong>Legal Authorities:</strong> If required by law or to protect our rights.</li>
                </ul>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">6. Your Data Protection Rights</h2>
                <p>Depending on your location, you may have the following rights:</p>
                <ul className="tw-list-disc tw-pl-6 tw-mb-4">
                  <li>The right to access your personal data</li>
                  <li>The right to rectification of your personal data</li>
                  <li>The right to erasure of your personal data</li>
                  <li>The right to restrict processing of your personal data</li>
                  <li>The right to data portability</li>
                  <li>The right to object to processing of your personal data</li>
                </ul>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">7. Cookies and Tracking Technologies</h2>
                <p>
                  We use cookies and similar tracking technologies to track activity on our services and hold
                  certain information. You can instruct your browser to refuse all cookies or to indicate when
                  a cookie is being sent.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">8. Children's Privacy</h2>
                <p>
                  Our services are not intended for children under the age of 13. We do not knowingly collect
                  personal information from children under 13. If you are a parent or guardian and you are
                  aware that your child has provided us with personal information, please contact us.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">9. Changes to This Privacy Policy</h2>
                <p>
                  We may update our Privacy Policy from time to time. We will notify you of any changes by
                  posting the new Privacy Policy on this page and updating the "Last Updated" date.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">10. Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at{' '}
                  <a href="mailto:corp@protega.ai">corp@protega.ai</a>.
                </p>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Privacy;
